import "./App.scss";

import { ThemeProvider } from "./theme";
import Container from "@material-ui/core/Container";

import { BrowserRouter as Router, Switch, Route } from "react-router-dom";
import Home from "./pages/Home";
import Rc from "./pages/Rc";
import { useEffect } from "react";

import useScript from "./services/useScript"

function App() {

  useEffect(() => {
    const canvas = document.createElement("canvas");
    canvas.className = 'fireworks';
    document.body.appendChild(canvas);
  }, []);

  const animejs = useScript("https://cdn.jsdelivr.net/npm/animejs@latest");
  const firework = useScript("js/firework.js");

  useEffect(() => {
    console.log(`Firework.js: ${firework}, Anime.js: ${animejs}`);
  }, [firework, animejs]);

  return (
    <ThemeProvider>
      <Container maxWidth="sm">
        <Router>
          <Switch>
            <Route path="/ac/rc">
              <Rc />
            </Route>
            <Route path="/ac/">
              <Home />
            </Route>
          </Switch>
        </Router>
      </Container>
    </ThemeProvider>
  );
}

export default App;
